import React, { useEffect, useState } from "react";
import CustomScrollbars from "../../../../util/CustomScrollbars";
import { Divider } from "antd";
import ToDoItem from "../ToDoItem";
import { useDispatch, useSelector } from "react-redux";
import { onGetReminder } from "../../../../appRedux/actions/Reminder";
import Auxiliary from "../../../../util/Auxiliary";
import IntlMessages from "../../../../util/IntlMessages";

const ToDoListForNotification = ({
  toDos,
  onTodoSelect,
  onTodoChecked,
  onMarkAsStart,
  pageIndexReset,
}: any) => {
  const [force, setForce] = useState(true);
  const [pageIndex, setPageIndex] = useState(0);
  const [requestSent, setRequestSent] = useState(false);

  const dispatch = useDispatch();

  let pageNum = 0;

  // useEffect(() => {
  //     return () =>
  //         alert('Disable Notification');
  // }, [])
  //---------------------------------------------------
  const handleOnScrollToDo = () => {
    if (true) {
      let parentElement = document.getElementsByClassName(
        "gx-module-content-scroll-notification"
      );

      if (!parentElement || !parentElement[0] || !parentElement[0].children[0])
        return;

      let element = parentElement[0].children[0];
      let scrollTop = (element && element.scrollTop) || document.body.scrollTop;
      let scrollHeight =
        (element && element.scrollHeight) || document.body.scrollHeight;
      let clientHeight = element.clientHeight || window.innerHeight;
      let scrolledToBottom =
        Math.ceil(scrollTop + clientHeight) >= scrollHeight;

      if (scrolledToBottom) {
        querySearchResult();
      }
    }
  };

  const querySearchResult = () => {
    if (requestSent) {
      return;
    }

    setTimeout(() => doQuery(), 500);
    setRequestSent(true);
  };

  const doQuery = () => {
    pageNum++;

    let append = pageNum == 0 ? false : true;

    dispatch(
      onGetReminder({
        page: pageNum,
        onlyApproved: false,
        onlyforce: force,
        searchText: null,
        append: append,
        isNotify: true,
      })
    );
    setPageIndex(pageIndex + 1);
    setRequestSent(false);
  };

  //---------------------------------------------------
  useEffect(() => {
    window.addEventListener("scroll", handleOnScrollToDo, true);

    dispatch(
      onGetReminder({
        page: pageNum,
        onlyApproved: false,
        onlyforce: force,
        searchText: null,
        append: false,
        isNotify: true,
      })
    );
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScrollToDo, true);
    };
  }, []);

  return (
    <Auxiliary>
      <div className="gx-popover-header">
        <h3 className="gx-mb-0">
          <IntlMessages id="appPublicWord.remineRemainders" />{" "}
          <span className="gx-fs-md">
            {" "}
            ({toDos.forceItems.length + toDos.pendingItems.length}){" "}
          </span>
        </h3>
        {/* <i className="gx-icon-btn icon icon-charvlet-down" /> */}
      </div>
      <CustomScrollbars
        style={{ height: "80px" }}
        className="gx-popover-scroll gx-module-content-scroll-notification"
      >
        <ul className="gx-sub-popover gx-px-0">
          {toDos &&
            toDos.forceItems &&
            toDos.forceItems.map((todo: any, index: number) => (
              <ToDoItem
                key={index}
                index={index}
                todo={todo}
                done={false}
                type="forceItems"
                pageIndexReset={pageIndexReset}
                lastItemInList={
                  toDos.forceItems.length - 1 === index &&
                  toDos.pendingItems.length === 0
                }
                onTodoSelect={onTodoSelect}
                onMarkAsStart={onMarkAsStart}
                onTodoChecked={onTodoChecked}
              />
            ))}

          {toDos &&
            toDos.pendingItems &&
            toDos.pendingItems.map((todo: any, index: number) => (
              <ToDoItem
                key={index}
                index={index}
                todo={todo}
                done={false}
                type="pendingItems"
                pageIndexReset={pageIndexReset}
                lastItemInList={toDos.pendingItems.length - 1 === index}
                onTodoSelect={onTodoSelect}
                onMarkAsStart={onMarkAsStart}
                onTodoChecked={onTodoChecked}
              />
            ))}
        </ul>
      </CustomScrollbars>
    </Auxiliary>
  );
};

export default ToDoListForNotification;
